import { getUrl, Post, Get, Put, Patch, Download, DownloadPost, Upload } from '.'

export const List = async body => {
  return Post(getUrl('cnps.css.task.search'), body)
}

export const WorkGroupList = async body => {
  return Post(getUrl('cnps.wkcldras.wkgroup.list'), body)
}

export const WorkTaskList = async body => {
  return Post(getUrl('cnps.wkcldras.wktask.list'), body)
}

export const WorkFormList = async body => {
  return Post(getUrl('cnps.wkcldras.form.list'), body)
}

export const TaskAdd = async body => {
  return Post(getUrl('cnps.css.task.insert'), body)
}

export const TaskAddAll = async body => {
  return Post(getUrl('cnps.css.task.insert-many'), body)
}

export const TaskDetail = async id => {
  return Get(getUrl('cnps.css.task.get', { id }))
}

export const TaskProcess = async (id, body) => {
  return Put(getUrl('cnps.css.task.edit', { id }), body)
}

export const TaskUpdate = async (id, body) => {
  return Put(getUrl('cnps.css.task.update-on-web', { id }), body)
}

export const TaskUpdateStatus = async (id, body) => {
  return Put(getUrl('cnps.css.task.change.status', { id }), body)
}

export const TaskUpdateCalcel = async (id, body) => {
  return Put(getUrl('cnps.css.task.cancel', { id }), body)
}

export const QuestionList = async body => {
  return Post(getUrl('cnps.wkcldras.question.list'), body)
}

export const CollectedInfoUpdate = async body => {
  return Post(getUrl('cnps.wkcldras.question.update'), body)
}

export const DownloadFileTemplate = async () => {
  return Download(getUrl('cnps.css.task.download-template'))
}

export const UploadFileListTask = async (formData, callback) => {
  return Upload(getUrl('cnps.css.task.import-file-v1'), formData, callback)
}

export const TaskUpdateTransformStatus = async body => {
  return Post(getUrl('cnps.css.task.convert-contract-to-nl.update-transform-status'), body)
}

export const DownloadFileError = async body => {
  return Post(getUrl('cnps.css.task.download-file-error'), body, {
    responseType: 'blob',
  })
}

export const contractNLOtp = async body => {
  return Post(getUrl('cnps.css.task.gen-otp.convert-contract-to-nl'), body)
}

export const contractNLConfirm = async body => {
  return Post(getUrl('cnps.css.task.update-task.convert-contract-to-nl'), body)
}

export const contractNLGetInfoMerchant = async body => {
  return Post(getUrl('cnps.css.task.get-info-merchant'), body)
}

export const contractNLStatus = async mposId => {
  return Get(
    `${window._env_?.VUE_APP_GET_LINK_CONFIRM ?? process.env.VUE_APP_GET_LINK_CONFIRM}/${mposId}`
  )
}

// gán sale
export const DownloadFileTemplateSale = async () => {
  return DownloadPost(getUrl('cnps.css.task.download-template-import-update-handler'))
}

export const UploadFileListTaskSale = async (formData, callback) => {
  return Upload(getUrl('cnps.css.task.import-update-handler'), formData, callback)
}

// export const DownloadFileTemplatePriority = async () => {
//   return Download(getUrl('cnps.css.task.download-template'))
// }

export const DownloadFileTemplatePriority = async () => {
  return DownloadPost(getUrl('cnps.css.task.download-template-v1'), {
    template: 'TEMPLATE_IMPORT_UPDATE_PRIORITY_TASK',
  })
}

export const UploadFileListTaskPriority = async (formData, callback) => {
  return Upload(getUrl('cnps.css.task.import-update-priority'), formData, callback)
}

export const updateTaskSupportCustomer = async body => {
  return Post(getUrl('cnps.css.task.update-task.support-customer'), body, {
    headers: {
      Authorization: null,
    },
  })
}

export const updateTaskSaleSupportCustomer = async body => {
  return Post(getUrl('cnps.css.task.update-task.sale-support-customer'), body)
}
